import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import {SET_TAB_INDEX} from '../../redux/types';
import styles from '../../utils/navTabStyle';


const useStyles = makeStyles(theme => ({
  ...styles
}))

const NavTab = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const tabIndex = useSelector(state => state.data.tabIndex);

useEffect(() => {
     setValue(tabIndex);
  }, []);

const handleChange = (event, newValue) => {
    setValue(newValue);
     dispatch({type: SET_TAB_INDEX, payload: newValue})
  };
  return (
  
      <AppBar
        component="div"
        className={classes.secondaryBar}
        color="primary"
        position="sticky"
        elevation={0}
      >
        <Tabs value={tabIndex ? tabIndex: 0} onChange={handleChange} >
          <Tab textColor="inherit"  label="Data" />
          <Tab textColor="inherit"   label="Choropleth" />
          
        </Tabs>
      </AppBar>

  );
}

NavTab.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default NavTab;
// <Tab textColor="inherit" label="Choroplet" />
//<Tab textColor="inherit" label="Latest News" />
//TabIndicatorProps={{style: {background:'green'}}}